import { render, staticRenderFns } from "./ListClient.vue?vue&type=template&id=1971292e"
import script from "./ListClient.vue?vue&type=script&lang=js"
export * from "./ListClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports